export const DEFER_INIT_EVENTS = ["touchmove", "focus", "blur", "scroll", "resize", "mousemove"];